module.exports = __webpack_public_path__ + "img/teacherName.e946259c.png";